<template>
    <div class="dashboard-container">
      <header class="dashboard-header">
        <img :src="`${publicPath}assets/logo.png`" alt="Platform Logo" class="platform-logo" />
        <h1>Case Assessment & Management</h1>
        <p class="subtitle subtitle-long">
          The R-CAT & E-CAT platforms allow clinicians to assess restorative and endodontic case complexity, as well as comprehensively manage
          cases using patient information leaflets and dynamic consent forms, as well as a referral management
          system with access to a network of experienced clinicians and specialists.
        </p>
        <p class="subtitle">Please select the assessment tool you wish to use.</p>
      </header>
  
      <main class="selection-area">
         <div class="system-card rcat-card" @click="selectSystem('rcat')">
          <div class="card-content">
            <h2>Restorative Complexity Assessment</h2>
            <!-- <p class="system-subtitle">Tool</p> -->
            <p class="description">
              Comprehensively assess the feasibility or practicality of providing restorative treatment for a tooth. This also includes assessment of the endodontic complexity (E-CAT) if required.
            </p>
            <p class="description">
              Based on the overall complexity of the case and the patient’s suitability for treatment, the Restorative Complexity Assessment Tool (R-CAT) will generate a recommendation for treatment planning, as well as provide access to a referral platform of experienced clinicians and specialists, if an onward referral is desired.
            </p>
          </div>
          <button class="select-button">R-CAT</button>
        </div>
        <div class="system-card ecat-card" @click="selectSystem('ecat')">
          <div class="card-content">
            <h2>Endodontic Complexity Assessment</h2>
            <!-- <p class="system-subtitle">Endodontic Complexity Assessment Tool</p> -->
            <p class="description">
              Systematically assess the challenges involved in providing endodontic treatment.
            </p>
            <p class="description">
              The Endodontic Complexity Assessment Tool (E-CAT) will calculate the endodontic difficulty or complexity level for the tooth and provide a recommendation for the appropriate experience required to treat the case.
            </p>
            <p class="description">
              Completing an assessment will also provide access to electronic consent forms and patient information leaflets, as well as a referral platform of experienced endodontists, if an onward referral is desired.
            </p>
          </div>
          <button class="select-button">E-CAT</button>
        </div>
      </main>
  
      <footer class="dashboard-footer">
        <p>© {{ new Date().getFullYear() }} University of Liverpool All rights reserved.</p>
      </footer>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DashboardSelection',
    emits: ['system-selected'],
    methods: {
      selectSystem(system) {
        this.$emit('system-selected', system);
      },
    },
  };
  </script>
  
  <style scoped>
  .dashboard-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f0f2f5;
    padding: 20px;
    box-sizing: border-box;
    font-family: 'Source Sans Pro', sans-serif; 
    color: #333;
  }
  
  .dashboard-header {
    text-align: center;
    margin-bottom: 40px;
  }
  
  .platform-logo {
    margin-top: 10px;
    max-height: 50px; 
  }
  
  .dashboard-header h1 {
    font-size: 2.2rem;
    color: #013B82;
    margin-bottom: 8px;
    font-weight: 700;
    margin-top: 30px;
  }
  
  .dashboard-header .subtitle {
    font-size: 1.1rem;
    color: #555;
    margin-top: 20px;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  .dashboard-header .subtitle-long {
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .selection-area {
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 100%;
    max-width: 800px;
  }
  
  @media (min-width: 768px) {
    .selection-area {
      flex-direction: row;
      gap: 30px;
    }
    .dashboard-header h1 {
      font-size: 2.5rem;
    }
    .dashboard-header .subtitle {
      font-size: 1.2rem;
    }
  }
  
  .system-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 25px;
    text-align: center;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    flex: 1;
    display: flex;
    flex-direction: column; 
  }
  
  .system-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  }
  
  .card-content {
    flex-grow: 1;
  }
  
  .system-card h2 {
    font-size: 1.8rem; 
    margin-top: 0;
    margin-bottom: 5px;
    font-weight: 600;
    line-height: 40px;
  }
  
  .system-card .system-subtitle {
    font-size: 1rem;
    color: #444;
    line-height: 1.4;
    margin-bottom: 15px;
    font-weight: 500;
  }
  
  .system-card .description {
    font-size: 0.9rem;
    color: #666;
    line-height: 1.5;
    margin-bottom: 20px;
  }
  
  .ecat-card h2 {
    color: #013B82; 
  }
  .ecat-card .select-button {
    background-color: #013B82;
  }
  .ecat-card .select-button:hover {
    background-color: #002c66; 
  }
  
  .rcat-card h2 {
    color: #138496; 
  }
  .rcat-card .select-button {
    background-color: #17a2b8; 
  }
  .rcat-card .select-button:hover {
    background-color: #117a8b;
  }
  
  
  .select-button {
    color: white;
    border: none;
    padding: 12px 25px;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
    margin-top: auto;
  }
  
  .dashboard-footer {
    margin-top: 50px;
    text-align: center;
    font-size: 0.85rem;
    color: #777;
  }
  </style>